import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Typography } from 'antd'
import { Folders } from 'types/building'

import RightArrowIcon from 'components/icons/RightArrowIcon'

import FolderIcon from './FolderIcon'

type Props = {
  listFolder: Folders[]
}

export default function ListFolder({ listFolder }: Props) {
  const [searchParams, setSearchParams] = useSearchParams()
  const folder = searchParams.get('folder')

  const totalNumberOfFile = useMemo(
    () =>
      listFolder.reduce((count, item) => {
        return count + (item.numberOfFile || 0)
      }, 0),
    [listFolder]
  )

  const hanldeSelectFolder = (folder: Folders) => {
    searchParams.set('folder', `${folder.id}`)
    setSearchParams(searchParams)
  }

  if (folder) return null

  return (
    <>
      <div className="bg-white">
        {listFolder.map((item, index) => (
          <div
            key={item.id}
            className={`h-[60px] px-5 flex items-center gap-[16px] border-0 border-b ${
              !index ? 'border-t' : ''
            } border-solid border-[#EEEFF2] cursor-pointer`}
            onClick={() => hanldeSelectFolder(item)}
          >
            <div className="h-[36px] w-[36px] flex justify-center">
              <FolderIcon type={item.id} size="large" />
            </div>
            <Typography className="font-medium text-[#021120]">
              {item.label}
            </Typography>
            <div className="ml-auto flex gap-3">
              <div
                className={`font-medium text-base ${
                  !item.numberOfFile ? 'text-[#A6AAAF]' : 'text-[#3B3C46]'
                }`}
              >
                {item.numberOfFile}ファイル
              </div>
              <RightArrowIcon color="#3B3C46" size={24} />
            </div>
          </div>
        ))}
      </div>
      {Boolean(listFolder.length) && (
        <div className="flex mr-3 ml-auto">
          <div className="text-[#3B3C46] text-base font-medium">
            合計：{totalNumberOfFile}ファイル
          </div>
        </div>
      )}
    </>
  )
}
